import { useState, useEffect, useContext, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PedidosFormContext } from "../../../context/pedidos/PedidosContext";
import { PedidosDetalleState } from "../../../context/pedidosdetalle/PedidosDetalleState";
import DatatableDetalle from "./pedidosdet/DatatableDetalle";
import FormButtons from "../../../components/FormButtons/FormButtons";
import FormField from "../../../components/FormField/FormField";
import Inputs from "./configForm/inputs";
import { formatDateTime, mediosPago } from "../../../helpers/dateUtils";
import ModalObs from "./modalObsFP/modalObs";
import { Grid, Typography, Box, Button } from '@mui/material';
import DatosPagoCliente from "./modalObsFP/DatosPagoCliente";
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import { handleInputChange } from "./helpersForm/formHandlers";

const nameData = "pedidos";

export const Form = ({ title }) => {
  const [form, setForm] = useState({});
  const { getPedidoByIdData, patchPedidoData } = useContext(PedidosFormContext);
  const [report, setReport] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [actualizaPedido, setActualizaPedido] = useState(0);
  const [catCliente, setCatCliente] = useState();
  const [datosCli, setDatosCli] = useState({});

  const nameData = "pedidos";
  const updateData = patchPedidoData;
  // Navigate to datagrid
  const navigate = useNavigate();
  const { id } = useParams();
  // Manejo de errores
  const [errors, setErrors] = useState({});
  // Estado de Carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Dialogs de advertencia y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // Estado para manejar el error
  const [estadoEdicionPedido, setEstadoEdicionPedido] = useState(false);

  // Manejo De Fechas
  const formatDateMemoized = useCallback(formatDateTime, []);

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id, actualizaPedido]);

  useEffect(() => { 
    if (!report) return;

    const cacheEmpl = report['cache-empl']; // 👈 CLAVE REAL

    setForm({
      ...report,
      createdAt: report.createdAt ? formatDateMemoized(report.createdAt) : "",
      oca_mobile_creation_date: report.oca_mobile_creation_date ? formatDateMemoized(report.oca_mobile_creation_date) : "",
      razon_social:
        report.cli_id === 1
          ? "Consumidor Final"
          : report.razon_social?.trim()
            ? report.razon_social
            : "",
      cli_name:
        report.cli_id === 1
          ? "Consumidor Final"
          : report.cli_name?.trim()
            ? report.cli_name
            : "",

      cli_categoria:
        report.cli_categoria === 0 ? "Mayorista" :
          report.cli_categoria === 1 ? "Minorista" :
            report.cli_categoria === 2 ? "Costo" : "Sin definir",
     cli_direccion: report.cli_direccion
  ? [
      report.cli_direccion,
      report.cli_nro_calle,
      report.cli_piso ? `Piso ${report.cli_piso}` : null,
      report.cli_dpto ? `Dpto ${report.cli_dpto}` : null,
    ]
      .filter(Boolean)
      .join(" ")
  : "No disponible",
      sel_name:
        report.sel_id === null
          ? "Página Web"
          : cacheEmpl
            ? [cacheEmpl.sel_lastname, cacheEmpl.sel_firstname]
              .filter(v => v && v.trim())
              .join(', ') || "Nombre No Disponible"
            : "Nombre No Disponible",

      oca_pago_estado:
        report.oca_pago_estado === 0 ? "Pago en Local" :
          report.oca_pago_estado === 1 ? "Transferencia" :
            report.oca_pago_estado === 2 ? "Mercado Pago" : "Sin definir",

      oca_state: report.oca_state,

      desc_descripcion: report.id_desc === 0 ? "Descuento Aplicado por Preventista" :
        report.desc_descripcion || "No se aplicó descuento",
    });

    setDatosCli(report.oca_datos_cli);
    setEstadoEdicionPedido(report.oca_state === 1 ?true:false)
  }, [report, formatDateMemoized]);

  const fetchData = async () => {
    const data = await getPedidoByIdData(id);
    setReport(data);
  };

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs, setErrors, form);
  };

  const validateForm = () => {
    let formErrors = {};

    // Validar los campos del formulario
    Inputs.forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) {
          formErrors[name] = error;
        }
      }
    });

    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };

  const handleSendData = () => {
    if (!validateForm()) {
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs.reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name;
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);

        if (errors.detalle) {
          errorMessagesArray.push(`Articulos: ${errors.detalle}`);
        }

        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray || "por favor verifique os errores");
        }

        return prevErrors;
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();

    try {
      if (id) {
        const { oca_state } = form;
        const dataToSend = { oca_state };

        await updateData(id, dataToSend);

      }
      navigate(`/${nameData}`);
    } catch (error) {
      console.error(error);
      openErrorDialog("Error al guardar los datos. Intenta nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/${nameData}`);
  };

  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);


  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);

  const camposFormulario = Inputs.map((input) => {

    // Ocultar descuento y total desc si los totales son iguales
    const hideDiscountFields =
      form.monto_total === form.monto_total_desc &&
      ["desc_descripcion", "monto_total_desc"].includes(input.name);

    if (hideDiscountFields) return null;

    // Campo desc_descripcion (aunque está readOnly y no tiene diferencias)
    if (input.name === "desc_descripcion") {
      return (
        <FormField
          key={input.name}
          input={input}
          value={form[input.name]}
        />
      );
    }
    // Campo desc_descripcion (aunque está readOnly y no tiene diferencias)
    if (input.name === "oca_state") {
      const isDisabled = form.oca_state === "Pagado";

      return (
        <FormField
          key={input.name}
          input={{ ...input, disabled: isDisabled }} // 👈 se lo pasamos al FormField
          value={form[input.name]}
          handleInputChange={(e) => handleChange(e)}
          error={errors[input.name]}
        />
      );
    }


    // Campo especial oca_datos_cli
    if (input.name === "oca_datos_cli") {
      return datosCli ? (
        <div key={input.name} className="formField">
          <label>Datos Del Pedido</label>
          <Button
            type="button"
            onClick={() => setOpenModal(true)}
            sx={{
              backgroundColor: '#1976d2 !important',
              color: '#fff !important',
              padding: '8px 24px !important',
              borderRadius: '8px !important',
              marginLeft: '10px !important',
              boxShadow: 'none !important',
              '&:hover': { backgroundColor: '#115293 !important' },
            }}
          >
            Ver
          </Button>
        </div>
      ) : null;
    }

    // Render normal
    return (
      <FormField
        key={input.name}
        input={input}
        value={form[input.name]}
      />
    );
  });

  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).replace(/([A-Z])/g, ' $1');

  const contenidoModal = datosCli ? (
    <Box sx={{ padding: 2 }}>
      <Grid container spacing={2}>
        {Object.entries(datosCli).flatMap(([key, value]) => {
          // Mostrar "Pagado con Mercado Pago"
          if (key === "mercadoPago" && value === true) {
            return (
              <Grid item xs={6} md={6} key={key}>
                <Typography variant="body2">
                  <strong>Estado de pago:</strong> Pagado con Mercado Pago
                </Typography>
              </Grid>
            );
          }

          // Desglosar objetos como "pago"
          if (typeof value === 'object' && value !== null) {
            return Object.entries(value).flatMap(([subKey, subValue]) => {
              // Mostrar "Dinero en cuenta" si medioPago === "account_money"
              if (subKey === "medioPago" && subValue === "account_money") {
                return (
                  <Grid item xs={6} md={6} key={`${key}.${subKey}`}>
                    <Typography variant="body2">
                      <strong>Medio de Pago:</strong> Dinero en cuenta
                    </Typography>
                  </Grid>
                );
              }

              // Ocultar tarjeta y cuotas si medioPago === "account_money"
              if (
                (subKey === "Tarjeta" || subKey === "cuotas") &&
                value["medioPago"] === "account_money"
              ) {
                return null;
              }

              return (
                <Grid item xs={6} md={6} key={`${key}.${subKey}`}>
                  <Typography variant="body2">
                    <strong>{capitalize(subKey)}:</strong> {subValue ?? "No disponible"}
                  </Typography>
                </Grid>
              );
            });
          }

          // Valores normales
          return (
            <Grid item xs={6} md={6} key={key}>
              <Typography variant="body2">
                <strong>{capitalize(key)}:</strong> {value ?? "No disponible"}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  ) : (
    <Typography>No hay datos para mostrar.</Typography>
  );
  const actualizaTotalPedido = () => {
    setActualizaPedido(prev => prev + 1);
  };

  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>

        <div className="bottom">
          <div className="right">
            <form>
              {camposFormulario}
            </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            <PedidosDetalleState>
              <DatatableDetalle
                pedidoid={id}
                catcli={catCliente}
                actualizaTotalPedido={actualizaTotalPedido}
                estadoEdicionPedido={estadoEdicionPedido}
              />
            </PedidosDetalleState>
            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title=""
            />
            {openModal && (
              <ModalObs onClose={() => setOpenModal(false)} title="Datos del pedido">
                <div className="modalContent">
                  <DatosPagoCliente datosCli={datosCli} />
                </div>
              </ModalObs>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
